import { Component, Element, h, Host, Prop } from '@stencil/core';

import { makeThemeable } from './uui-theme';

@Component({
  tag: 'uui-themed-container',
  shadow: true,
  styleUrl: 'uui-themed-container.css'
})
export class UUIThemedContainer {
  @Prop() theme = 'default';
  @Prop({ reflect: true }) hideswatch = false;
  @Prop({ reflect: true }) hidethemeselector = false;
  @Prop({ reflect: true }) hideCheckers = false;
  @Element() el: HTMLElement;

  constructor() {
    makeThemeable(this, () => this.el);
  }

  toggleCheckers() {
    this.hideCheckers = !this.hideCheckers;
  }

  toggleSwatch() {
    this.hideswatch = !this.hideswatch;
  }

  render() {
    const swatch = this.hideswatch ? null : (
      <uui-theme-swatch></uui-theme-swatch>
    );
    return (
      <Host>
        <uui-themed-background checkeredBackground={!this.hideCheckers}>
          <div
            class="controls">
            <uui-theme-selector></uui-theme-selector>
            <uui-checkbox
              onChange={() => this.toggleCheckers()}
              checked={!this.hideCheckers}
            >
              Checked Background
            </uui-checkbox>
            <uui-checkbox
              onChange={() => this.toggleSwatch()}
              checked={!this.hideswatch}
            >
              Theme Palette Swatch
            </uui-checkbox>
          </div>
          <uui-base-theme></uui-base-theme>
          <slot />
          {swatch}
        </uui-themed-background>
      </Host>
    );
  }
}
